import { render, staticRenderFns } from "./work-flow.vue?vue&type=template&id=56f13743&scoped=true&"
import script from "./work-flow.vue?vue&type=script&lang=js&"
export * from "./work-flow.vue?vue&type=script&lang=js&"
import style0 from "./work-flow.vue?vue&type=style&index=0&id=56f13743&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f13743",
  null
  
)

export default component.exports